require('./angular-ui-switch.css');
require('./angular-ui-switch.js');
module.exports = 'uiSwitch';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-ui-switch/index.js
 ** module id = 651
 ** module chunks = 1
 **/